
$('.custom-featured-collection .product-grid').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
});

function openCity(cityName) {
	var i;
	var x = document.getElementsByClassName("city");
	for (i = 0; i < x.length; i++) {
		x[i].style.display = "none";  
	}
	document.getElementById(cityName).style.display = "block";  
}

$(document).ready(function() {
	let productsOnPage = $('.collection-grid');
	let nextUrl = productsOnPage.attr('data-next-url');
	let products = productsOnPage.attr('data-product-count');
	let productsPerPage = productsOnPage.attr('data-product-to-show');
	let currentProduct = 0;

	if(products < 18) {
		currentProduct = products
		$('.dynamic-product-count').each(function(index) {
			$(this).text('Showing ' + currentProduct + ' of ' + products)
		});
	} else {
		currentProduct = productsPerPage
		$('.dynamic-product-count').each(function(index) {
			$(this).text('Showing ' + currentProduct + ' of ' + products)
		});
	}

	$('.load-more-btn').click(function(e) {
		e.preventDefault();
		$.ajax({
			url: nextUrl,
			type: "GET",
			dataType: "html",
			success: function(nextPage) {
				let newProducts = $(nextPage).find('.collection-grid');
				productsOnPage.append(newProducts.html());
				let newUrl = newProducts.attr('data-next-url');
				nextUrl = newUrl;
				if(newProducts.attr('data-current_page') == newProducts.attr('data-pages')) {
					$('.load-more-wrapper').each(function(index) {
						$(this).css("display", "none");
					})

					$('.dynamic-product-count').each(function(index) {
						$(this).text('Showing ' + products + ' of ' + products)
					});
				} else {
					currentProduct = parseInt(currentProduct) + 18
					$('.dynamic-product-count').each(function(index) {
						$(this).text('Showing ' + currentProduct + ' of ' + products)
					});
				}
			}
		})
	})


	const cloneRating = $('.jdgm-preview-badge')[0];
	$('#ratingWrapper').append(cloneRating);
	const cloneReview = $('#shopify-block-judge_me_reviews_review_widget_88jf6A');
	$('#reviewsWrapper').append(cloneReview);


	$('.custom-tab-container').hide();
	$('#tab1C').fadeIn('slow');
	$('#tabContentWrapper').css('display', 'block')
	$('#customProductTabs li a').click(function(){
		var t = $(this).attr('id');
			if($(this).hasClass('inactive')){ //this is the start of our condition 
				$('#customProductTabs li a').addClass('inactive');           
				$(this).removeClass('inactive');

				$('.custom-tab-container').hide();
				$('#'+ t + 'C').fadeIn('slow');
		}
	});
})